import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatNumber = (value: number) => {
  if (value < 1000) {
    return value.toString();
  }
  if (value >= 1000 && value < 1000000) {
    return (value / 1000).toFixed(1) + 'K';
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + 'M';
  }

  return value.toString();
};

const isValidInsUsername = (username: string) => {
  const valid = /^[A-Za-z0-9_](?!.*\\.\\.)([A-Za-z0-9_.]{0,28}[A-Za-z0-9_])?$/.test(username);
  if (username.endsWith('.')) return false;
  if (username.includes('..')) return false;
  if (username.length < 1 || username.length > 30) return false;
  return valid;
};

export const isInsUserUrl = (str: string) => {
  const match = str.match(/^@?https?:\/\/(www\.)?instagram\.com\/([^/?#]+)(?:[/?#].*)?$/);
  if (match) {
    console.log(match[2]);

    if (match[2]) {
      return match[2];
    } else {
      return null;
    }
  }
  if (isValidInsUsername(str)) {
    return str;
  }
  return null;
};
